import styled from "styled-components";

import color from "../../constants/color";
import materialUI from "../../material-UI";

export const useStyles = materialUI.makeStyles({
  root: {
    "& fieldset": {
      borderWith: "1px",
      borderColor: "#D0D5DD",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2D5BFF !important",
    },
    "& input::placeholder": {
      textOverflow: "ellipsis !important",
      color: "#000000",
      opacity: "1",
    },
  },
});

export const Container = styled(materialUI.Container)`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: 130px;
  -webkit-font-smoothing: antialiased;
`;
export const FormControl = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px 24px 20px 24px;
  padding: 45px 18px 0px 18px;
  background-color: ${color.White};
  border-radius: 16px;
`;
export const FormGroupColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
`;
export const FormGroupRow = styled.div`
  display: flex;
  flex-direction: row;
  @media only screen and (max-width: 760px) {
    flex-direction: column;
    margin-right: 30px;
  }
`;
export const Space = styled.div`
  width: 54px;
`;
export const ColumnIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    color: ${color.VivazBlack};
    font-family: Inter;
    margin-top: 4px;
  }
`;
export const ContainerTemperature = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 380px;
`;

export const ContainerAutocomplete = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
interface LabelProps {
  color: string;
}
export const Label = styled.label<LabelProps>`
  font-size: 14px;
  font-family: Inter;
  margin-bottom: 8px;
  color: ${(props) => props.color || color.grey1};
`;
